module.exports = __webpack_public_path__ + "h5/img/bg_upload_by_link_2.70003df0.70003df0.png";